import { Styles, generateClasses } from 'netline-ui';

export const mobileUserInfoClasses = generateClasses('MobileUserInfo', ['root', 'avatar', 'userInfo'] as const);

const styles: Styles = ({ theme: { colors } }) => ({
  [`.${mobileUserInfoClasses.avatar}`]: {
    color: colors.yellow[500],
  },
  [`.${mobileUserInfoClasses.userInfo}`]: {
    '.MuiListItemText-primary': {
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '20px',
      letterSpacing: 0.15,
    },
    '.MuiListItemText-secondary': {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: 0.25,
      color: colors.grey[600],
    },
  },
});

export default styles;
